import dayjs from 'dayjs';
import { atom } from 'jotai';
import { groupBy, sumBy } from 'lodash';

import { YEAR_MONTH_DAY_FORMAT } from '@/constants/date.constants';
import type { EventsPerDayDTO } from '@/pages/Dashboard/Dashboard.types';

export const deviceEventsPerDayAtom = atom<EventsPerDayDTO[]>([]);

export const deviceEventsByDateAtom = atom((get) => {
  const deviceEventsPerDay = get(deviceEventsPerDayAtom);
  const timeFrame = 30;
  const groupedEvents = groupBy(deviceEventsPerDay, 'date');

  const now = dayjs();

  const data = [];

  // make sure every day is represented in the array by looping through the time frame and checking if there is a record for that day
  for (let i = 0; i <= timeFrame; i += 1) {
    const date = `${now
      .subtract(timeFrame - i, 'days')
      .format(YEAR_MONTH_DAY_FORMAT)}`;

    const count = groupedEvents[date] ? sumBy(groupedEvents[date], 'count') : 0;
    data.push({ date: dayjs(date).toDate(), count });
  }

  return data;
});
